import React from 'react';
import { ChartFactory } from '../ChartFactory/ChartFactory';
export const LineChart = (props) => {
    return React.createElement(ChartFactory, { ...props, chartType: "line" });
};
